export default __webpack_public_path__ + "static/media/refresh-green.4a59e41d.svg";